import React, { useState, createContext, useEffect } from "react";
import UserService from "../keycloak/UserService";
import { getUserPermissions, getUserRole } from "../api/admin";

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const currusername = UserService.getUsernames();
  const [data, setData] = useState([]);
  const [role, setRole] = useState([]);
  // userId was not assigneed properly, hence issuer,verifier,news feed tab getting vanished
  const [userId, setUserId] = useState(
    localStorage.getItem("userId") || undefined,
  );
  const [username, setUsername] = useState(currusername);

  const [userPermissions, setUserPermissions] = useState([]);

  const [addNetwork, setAddNetwork] = useState({
    createdBy: parseInt(localStorage.getItem("userId")),
    // createdBy: userId ? parseInt(userId) : '',
    name: "",
    description: "",
    publicUrl: "",
    regionId: "southeastasia",
    numberOfNodes: 4,
    networkStatus: "pending",
    versionTag: "v1.0",
    active: false,
  });
  const [addAdmin, setAddAdmin] = useState({
    email: "",
    networkId: "",
  });

  const updateAdminData = (data) => {
    setAddAdmin((prev) => ({ ...prev, ...data }));
  };

  const updateNetworkData = (data) => {
    setAddNetwork((prev) => ({ ...prev, ...data }));
  };

  useEffect(() => {
    setAddNetwork((prev) => ({ ...prev, createdBy: userId }));
  }, [userId]);
  useEffect(() => {
    const fetchAuthData = async () => {
      if (!userId) return;

      try {
        const [permissionsResponse, roleResponse] = await Promise.all([
          getUserPermissions(userId),
          getUserRole(userId),
        ]);
        setUserPermissions(permissionsResponse.data?.permissions || []);
        const fetchedRole = roleResponse.data?.[0]?.name || "guest";
        setRole(fetchedRole);
      } catch (error) {
        console.error("Failed to fetch user data (role/permissions):", error);
      }
    };

    fetchAuthData();
  }, [userId]);

  return (
    <AdminContext.Provider
      value={{
        data,
        setData,
        addNetwork,
        setAddNetwork,
        updateNetworkData,
        addAdmin,
        setAddAdmin,
        updateAdminData,
        userId,
        setUserId,
        username,
        setUsername,
        userPermissions,
        setUserPermissions,
        role,
        setRole,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
